import { SessionDto, ServiceResponse, AddressDto, AddressSearchResultsDto } from "@se/platform";

const IAddressLookupServiceId = Symbol("IAddressLookupService");

interface IAddressLookupService {
    searchAddresses(session: SessionDto, searchTerm: string) : Promise<ServiceResponse<AddressSearchResultsDto>>;
    
    getAddress(session: SessionDto, addressId: string) : Promise<ServiceResponse<AddressDto>>;
};

export { IAddressLookupServiceId, IAddressLookupService }